import * as Yup from 'yup';
import { InvoiceTypes, PaymentMethod } from 'src/utils/constants/cfdi';

export default Yup.object().shape({
  invoiceType: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  contractId: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  clientId: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  clientName: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  folio: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  amount: Yup.number()
    .typeError('SCHEMA_ERRORS.MUST_BE_NUMBER')
    .required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  comment: Yup.string().nullable(),
  paymentMethod: Yup.string().when('invoiceType', {
    is: value => value !== InvoiceTypes.PAYMENT,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD').nullable(),
    otherwise: schema => schema.nullable()
  }),
  paymentForm: Yup.string().when('paymentMethod', {
    is: PaymentMethod.PUE,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    otherwise: schema => schema.notRequired()
  }),
  paymentDate: Yup.string().when('paymentMethod', {
    is: PaymentMethod.PUE,
    then: schema => schema.required('SCHEMA_ERRORS.REQUIRED_FIELD'),
    otherwise: schema => schema.notRequired()
  }),
  cfdis: Yup.array().when('invoiceType', {
    is: InvoiceTypes.PAYMENT,
    then: schema =>
      schema
        .required('SCHEMA_ERRORS.REQUIRED_FIELD')
        .min(1, 'SCHEMA_ERRORS.REQUIRED_FIELD')
        .test(
          'valid-cfdis',
          'SCHEMA_ERRORS.REQUIRED_FIELD',
          value =>
            value && value.length > 0 && value.every(cfdi => cfdi && cfdi.id)
        ),
    otherwise: schema => schema.notRequired()
  })
});
